import styled from 'styled-components';

import { BasicContainer } from '../../common/styles/oc-styled-components';
import {
  BREAKPOINTS,
  colors,
  FONT_FAMILIES,
} from '../../common/styles/style-constants';
import Error from '../common/components/Error/Error';

export const Main = styled.main`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  font-size: 18px;
`;

export const ButtonBlock = styled.div`
  bottom: 0;
  left: 50%;
  width: 100%;
  max-width: 768px;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  padding: 10px 10px;

  & > * {
    margin: 0 5px;
  }

  /* For screen sizes TALLER than an average 15" monitor */
  @media (min-width: ${BREAKPOINTS.tabletMin}px) and (min-height: 1030px) {
    bottom: -50px;
  }
`;
const BaseOpenSansButton = styled.button`
  appearance: none;
  border: none;
  cursor: pointer;
  background: none;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${FONT_FAMILIES.openSans};
  font-weight: 400;
  line-height: 18px;
  font-size: 12px;
  letter-spacing: -0.015em;
  padding: 8px 20px;
  transition: all 0.1s ease-in-out;

  & > .anticon {
    margin-right: 5px;
  }
`;

export const TertiaryButton = styled(BaseOpenSansButton)`
  color: ${colors.sage7};
  border: 1px solid ${colors.sage7};

  &:hover,
  &:focus {
    color: ${colors.white};
    border-color: ${colors.sage6};
    background-color: ${colors.sage6};
    outline: none !important;
  }
`;

// Step Architecture
export const StepWrapper = styled.div`
  margin-top: 20px;
  padding-bottom: 86px;

  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    width: ${(props) => props.width || '100%'};
    margin: 40px auto 0;
  }
`;

export const TopInsuranceWrapper = styled.div`
  margin-top: 20px;
  max-width: 768px;

  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    width: ${(props) => props.width || '100%'};
    margin: 40px auto 0;
  }
`;

export const MatchResultContainer = styled.div`
  max-width: 700px;
  margin: 0 auto;
  padding-top: 48px;
`;

export const MatchResultWarning = styled(Error)`
  margin-bottom: 30px;
  width: max-content;
  border-radius: 10px;
`;

export const ConciergeBasicContainer = styled(BasicContainer)`
  padding: ${(props) => (props.noPadding ? '0' : '0 5px')};
`;
